import styled from "styled-components"

export const AuthMethodLink = styled.div`
  text-align: center;
  font-size: 0.7rem;
  a {
    margin: 0 16px;
  }
`
